import moment from "moment";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { downloadCsv } from "../../utils";

const userParser = (user) => {
  let labRecords = [];

  if (user.labs && user.labs.length > 0) {
    labRecords = user.labs.map((lab) => ({
      Nome: user.name ? user.name : "",
      Sobrenome: user.lastName ? user.lastName : "",
      Documento: user.document ? user.document : "",
      "Tipo de Documento": user.typeUser ? user.typeUser?.name : "",
      Especialidade: user.specialties ? user.specialties : "",
      Cpf: user.cpf ? user.cpf : "",
      Uf: user.uf ? user.uf : "",
      "Usuario de Teste": user.isTestUser,
      "Data do Cadastro": moment(user.createdAt).format("DD/MM/YYYY"),
      "Data de Registro": user.registeredAt ? moment(user.registeredAt).format("DD/MM/YYYY") : "",
      "Laboratório": lab.name,
      "Categorias Terapêuticas": user.therapeuticCategories ? user.therapeuticCategories.map((i) => i.name).join(". ") : "",
      Ip: user.ip ? user.ip : "",
      "Origem": user.optinOrigin ? user.optinOrigin.name : "",
      "Navegador e Sistema": user.userAgent ? user.userAgent : "",
      "Dispositivo": user.device ? user.device : "",
      "Data da Assinatura": moment(user.acceptanceAt).format("DD/MM/YYYY"),
      "Hora da Assinatura": moment(user.acceptanceAt).format("HH:mm"),
      "Data de Expiração": moment(user.expirationAt).format("DD/MM/YYYY"),
      "Termo de Aceite": user.termOfAcceptance ? user.termOfAcceptance : ""
    }));
  }

  return labRecords;
};

export const exporter = (data) => {
  const dataForExport = data.flatMap(userParser);

  const csv = convertToCSV(
    {
      data: dataForExport,
      fields: [
        "Nome",
        "Sobrenome",
        "Documento",
        "Tipo de Documento",
        "Especialidade",
        "Cpf",
        "Uf",
        "Usuario de Teste",
        "Data do Cadastro",
        "Data de Registro",
        "Laboratório",
        "Categorias Terapêuticas",
        "Ip",
        "Origem",
        "Navegador e Sistema",
        "Dispositivo",
        "Data da Assinatura",
        "Hora da Assinatura",
        "Data de Expiração",
        "Termo de Aceite"
      ],
    },
    {
      delimiter: ";",
    }
  );

  downloadCsv(csv, "opt-in-users");
};
